import createDataContext from "./createDataContext";
// import React from 'react'









const dataReducer = (state, action) => {
    switch (action.type) {
        case 'setCustomers':
            return { ...state, customers: action.payload }
        case 'setProducts':
            return { ...state, products: action.payload }
        case 'setStoreData':
            return { ...state, storeData: action.payload }
        case 'setManufacturs':
            return { ...state, manufacturs: action.payload }
        default: return state
    }

}


const setCustomersGlobal = dispatch => {
    return (data) => {
        dispatch({ type: 'setCustomers', payload: data })
    }
}

const setProductsGlobal = dispatch => {
    return (data) => {
        dispatch({ type: 'setProducts', payload: data })
    }
}

const setManufactursGlobal = dispatch => {
    return (data) => {
        dispatch({ type: 'setManufacturs', payload: data })
    }
}

const setStoreData = dispatch => {
    return async () => {
        return localStorage.getItem('store_data') &&
            dispatch({ type: 'setStoreData', payload: JSON.parse(localStorage.getItem('store_data')) })
    }
}

export const { Provider, Context } = createDataContext(
    dataReducer,
    {
        setCustomersGlobal,
        setProductsGlobal,
        setStoreData,
        setManufactursGlobal
    },
    {
        customers: [],
        products : [],
        storeData: [],
        manufacturs : [],
        customersState : null
    }
)